import React from 'react';
import styles from '../DailyTrainingPage.module.css';

/**
 * ChallengeSkeleton component for DailyTrainingPage
 * 
 * Displays a skeleton UI while a challenge is loading.
 * Used as a fallback for React.Suspense.
 */
const ChallengeSkeleton: React.FC = () => (
  <div className={styles.skeletonChallenge}>
    <div className={styles.skeletonHeader}></div>
    <div className={styles.skeletonContent}>
      <div className={styles.skeletonBoard}></div>
      <div className={styles.skeletonControls}>
        <div className={styles.skeletonButton}></div>
        <div className={styles.skeletonButton}></div>
      </div>
    </div>
  </div>
);

export default React.memo(ChallengeSkeleton); 